import ApexLogo from './ApexLogo';
import { Icons } from './Icons';
import LanguageSwitcher from './LanguageSwitcher';
import { LINKS } from '../constants';
import styles from './Navbar.module.css';

export default function Navbar({ scrolled, t, lang, setLang }) {
  const navLinks = [
    { label: t.howItWorks, href: '#how-it-works' },
    { label: t.products,   href: '#products'      },
    { label: t.tokenomics, href: '#tokenomics'   },
    { label: t.roadmap,    href: '#roadmap'       },
    { label: t.community,  href: '#community'     },
  ];

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <a href="#top" className={styles.brand}>
        <ApexLogo size={36} glow={false} />
        <div>
          <div className={styles.brandName}>APEX</div>
          <div className={styles.brandSub}>$APEX · TON</div>
        </div>
      </a>

      <div className={styles.links}>
        {navLinks.map(({ label, href }) => (
          <a key={href} href={href} className={styles.link}>{label}</a>
        ))}
      </div>

      <div className={styles.right}>
        <LanguageSwitcher lang={lang} setLang={setLang} />
        <a
          href={LINKS.buy}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.cta}
        >
          {t.buy} <Icons.Arrow />
        </a>
      </div>
    </nav>
  );
}
